// src/composables/useOffscreenIndicator.js

import { computed, toRefs } from 'vue';
import { OffscreenService } from '@/services/offscreen.service';
import { OFFSCREEN_CONFIG } from '@/constants/offscreen.constants';

/**
 * Offscreen indicator composable
 */
export function useOffscreenIndicator(props) {
  const { offscreenTop, offscreenBottom, offscreenLeft, offscreenRight } = toRefs(props);

  const showTop = computed(() => OffscreenService.shouldShowIndicator(offscreenTop.value));
  const showBottom = computed(() => OffscreenService.shouldShowIndicator(offscreenBottom.value));
  const showLeft = computed(() => OffscreenService.shouldShowIndicator(offscreenLeft.value));
  const showRight = computed(() => OffscreenService.shouldShowIndicator(offscreenRight.value));

  const hasVisibleIndicators = computed(() => 
    showTop.value || showBottom.value || showLeft.value || showRight.value
  );

  const offscreenCounts = computed(() => ({
    offscreenTop: offscreenTop.value,
    offscreenBottom: offscreenBottom.value,
    offscreenLeft: offscreenLeft.value,
    offscreenRight: offscreenRight.value,
  }));

  const totalOffscreenCount = computed(() => 
    OffscreenService.getTotalOffscreenCount(offscreenCounts.value)
  );

  const primaryDirection = computed(() => 
    OffscreenService.getPrimaryDirection(offscreenCounts.value)
  );

  const arrowIcon = OFFSCREEN_CONFIG.STYLING.ARROW_ICON;
  const badgeColor = OFFSCREEN_CONFIG.STYLING.BADGE_COLOR;

  const handleIndicatorClick = (direction) => {
    console.log(`Clicked ${direction} indicator`);
  };

  return {
    // Visibility states
    showTop,
    showBottom, 
    showLeft,
    showRight,
    hasVisibleIndicators,
    
    // Counts
    totalOffscreenCount,
    primaryDirection,
    
    // Simple styling
    arrowIcon,
    badgeColor,
    
    // Methods
    handleIndicatorClick,
  };
}